module.exports = __webpack_public_path__ + "static/img/solutionValuePic05.b01f735.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionValuePic05.png
// module id = VHwc
// module chunks = 0